import { Button, Form, Table } from "react-bootstrap";
import { useGetAllSubscriptionPayment } from "../../../API/subscriptionPayment.api";
import calculateDueMonths from "../../../utils/calculateDueMonths";
import request from "../../../utils/request";
import toast from "react-hot-toast";
import { useGetSoftwareInformationById } from "../../../API/softwareInformation.api";
import { useContext, useState } from "react";
import { UserContext } from "../../../Context/UserContextAPI";
import { generateSubscriptionInvoiceNumber } from "../../../utils/helper";
import ModalLayout from "../../../components/Layout/ModalLayout";

const SubscriptionPay = () => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isTermsAccepted, setIsTermsAccepted] = useState(false);

	const { data: subscriptionPayment } = useGetAllSubscriptionPayment();

	const { currentUser, settingsData } = useContext(UserContext);

	const { data: softwareInformation } = useGetSoftwareInformationById(1);

	const dueMonths = calculateDueMonths(
		subscriptionPayment,
		softwareInformation?.due_month_count_from,
	);

	const paymentHandler = async () => {
		if (dueMonths.length < 1) {
			toast.error("No due months found");
			return null;
		}
		try {
			const response = await request.create(
				"subscriptionPayment/payment/bkash/create",
				{
					amount: softwareInformation?.software_price * dueMonths.length,
					paymentDate: dueMonths,
					user_id: currentUser.id,
					invoiceNumber: generateSubscriptionInvoiceNumber(
						softwareInformation?.invoice_pattern,
					),
					payerReference: settingsData?.short_name || "GHofily",
				},
			);
			// console.log(response);
			if (response.status === "OK") {
				if (response.data.bkashURL) {
					window.location.href = response.data.bkashURL;
				} else {
					toast.error("Something went wrong");
				}
			}
		} catch (error) {
			toast.error(error.message);
		}
	};
	return (
		<div>
			<Button variant="success" onClick={() => setIsModalOpen(true)}>
				Pay Now
			</Button>

			{isModalOpen && (
				<ModalLayout
					title={"Payment"}
					isOpen={isModalOpen}
					onClose={() => setIsModalOpen(false)}
					size={"lg"}
				>
					<Table border hover striped>
						<tbody>
							<tr>
								<td>
									<h1>Payment To</h1>
								</td>
								<td>
									<h1>{softwareInformation?.owner_company_name}</h1>
								</td>
							</tr>
							<tr>
								<td>
									<h1>Payment From</h1>
								</td>
								<td>
									<h1>{softwareInformation?.customer_name}</h1>
								</td>
							</tr>
							<tr>
								<td>
									<h1>Payment Amount</h1>
								</td>
								<td>
									<h1>
										{(softwareInformation?.software_price || 0) *
											(dueMonths?.length || 0)}{" "}
										BDT
									</h1>
								</td>
							</tr>
							<tr>
								<td>
									<h1>Payment Method</h1>
								</td>
								<td>
									<h1>Bkash</h1>
								</td>
							</tr>
						</tbody>
					</Table>
					<div className="">
						<div className="d-flex justify-content-end">
							<Form.Check
								type="checkbox"
								checked={isTermsAccepted}
								onChange={(e) => setIsTermsAccepted(e.target.checked)}
								label="By accepting this payment, you agree to the terms and conditions"
								id="terms"
							/>
						</div>
						<div className="d-flex justify-content-end mt-2">
							<Button
								variant="success"
								onClick={paymentHandler}
								disabled={!isTermsAccepted}
							>
								Pay Now
							</Button>
						</div>
					</div>
				</ModalLayout>
			)}
		</div>
	);
};

export default SubscriptionPay;
